export default __webpack_public_path__ + "static/media/mo_premium_03.17ce609c.jpg";